// eslint-disable-next-line @nx/enforce-module-boundaries
import { useQuery } from '@occc-app/dataAccessLayer/utils';
import { useGetScanDataSftpCredentialsOverviewQuery } from '@occc/graphql';

export const useGetScanDataSftpCredentialsOverview = () => {
  return useQuery(useGetScanDataSftpCredentialsOverviewQuery);
};
